import React, { useEffect } from 'react'

import { Donut } from 'react-dial-knob';

import RDSBarChart from '../ChartsImpl/RDS/RDSBarChart';
import RDSWeeklyChart from '../ChartsImpl/RDS/RDSWeeklyChart';
import { useNavigate } from 'react-router-dom';

const DashboardContentModal = ({ data, showFullscreen, setShowFullscreen, regionalDataService, token, customerId, baseUrl, theme = 'light', toggleTheme }) => {

    const history = useNavigate();

    useEffect(() => {
        regionalDataService();

        const interval = setInterval(() => {
            regionalDataService();
        }, 60000); // 1 minute

        return () => clearInterval(interval);
    }, [])

    const navigateToDashboard = () => {
        history('/branch-dashboard')
    }

    const returnIntData = (data) => {
        if (data == null) {
            console.log("return 0");

            return 0;
        }
        console.log("return data");
        return data;
    }

    const returnPercentage = (data) => {
        if (data == null) {
            console.log("return 0");

            return 0;
        }
        console.log("return data");
        return data;
    }

    const returnColor = (data) => {
        if (data == null) {
            return 'rgba(220, 53, 69, 1)';
        } else if (data >= 50 && data < 75) {
            return 'rgba(204, 207, 45, 1)';
        } else if (data >= 75) {
            return 'rgba(23, 154, 71, 1)';
        } else {
            return 'rgba(220, 53, 69, 1)';
        }
    }

    const returnTextColor = (data) => {
        if (data == null) {
            return 'text-danger';
        } else if (data >= 50 && data < 75) {
            return 'text-warning';
        } else if (data >= 75) {
            return 'text-success';
        } else {
            return 'text-danger';
        }
    }

    function InfiniteScrollRow({ branchWiseServiceLevels = [] }) {

        if (!branchWiseServiceLevels.length) return null;

        // duplicate for infinite scroll
        const items = branchWiseServiceLevels.length > 6
            ? [...branchWiseServiceLevels, ...branchWiseServiceLevels]
            : [...branchWiseServiceLevels];


        return (
            <>
                {
                    branchWiseServiceLevels.length > 6 ? (
                        <div className="scroll-container mt-2">
                            <div className="scroll-content" style={{ minWidth: "180px", minHeight: "180px", background: 'transparent', borderRadius: '15px' }}>
                                {items.map((item, idx) => (
                                    <div
                                        key={idx}
                                        className="card ml-2"
                                        style={{ minWidth: "180px", background: 'transparent', borderRadius: '15px' }}
                                    >
                                        <div className="body w_knob" style={{ borderRadius: '15px' }}>
                                            <div className="c_know">
                                                <h4>{item.branchName}</h4>

                                                <Donut
                                                    className="knob"
                                                    diameter={150}
                                                    min={0}
                                                    max={100}
                                                    step={1}
                                                    value={item.serviceLevel ?? 0}
                                                    theme={{
                                                        donutThickness: 5,
                                                        donutColor: '#17C2D7',
                                                        centerColor: `${theme === 'light' ? 'white' : '#141c26'} `,
                                                        bgrColor: '#1f2b3aff'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="row clearfix">
                            {items.map((item, idx) => (
                                <div
                                    key={idx}
                                    className="col-lg-2 col-md-4 col-sm-6 p-1 ml-3"
                                >
                                    <div className="card" style={{ minWidth: "180px", minHeight: "180px",  background: 'transparent', borderRadius: '15px' }}>
                                        <div
                                            className="body w_knob"
                                            style={{
                                                borderRadius: '15px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '20px 0'
                                            }}
                                        >
                                            <h4 style={{ marginBottom: '10px' }}>{item.branchName}</h4>

                                            <Donut
                                                className="knob"
                                                diameter={150}
                                                min={0}
                                                max={100}
                                                step={1}
                                                value={item.serviceLevel ?? 0}
                                                theme={{
                                                    donutThickness: 5,
                                                    donutColor: '#17C2D7',
                                                    centerColor: `${theme === 'light' ? 'white' : '#141c26'} `,
                                                    bgrColor: '#1f2b3aff'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                    )
                }

            </>
        );
    }


    return (
        <>
            {showFullscreen ? (
                <div
                    className="fullscreen-overlay"
                    style={{ background: theme === 'light' ? '#f8f9fa' : '#0d141d', color: theme === 'light' ? '#111' : '#e5e7eb' }}
                >
                    <div
                        className="fullscreen-body"
                        style={{ background: theme === 'light' ? '#f8f9fa' : '#0d141d', color: theme === 'light' ? '#111' : '#e5e7eb' }}
                    >
                        <div className="d-flex justify-content-end align-items-center mb-2">
                            {toggleTheme && (
                                <button
                                    className={`btn btn-sm ${theme === 'light' ? 'btn-outline-secondary' : 'btn-outline-light'}`}
                                    onClick={toggleTheme}
                                >
                                    {theme === 'light' ? 'Dark' : 'Light'} Theme
                                </button>
                            )}
                            <button className="btn btn-sm btn-danger ml-2" onClick={() => {setShowFullscreen(false); navigateToDashboard()}}>Close</button>
                        </div>
                        <div
                            className={`container-fluid branch-dashboard rds-tv ${theme === 'light' ? 'rds-light' : 'rds-dark'}`}
                            style={{ background: theme === 'light' ? '#f5f6fa' : '#0b1119', color: theme === 'light' ? '#111' : '#e5e7eb', height: '100vh', paddingBottom: 0 }}
                        >
                            <>
                                <div className="row clearfix">

                                    {/* 1st row | 1st col*/}
                                    <div className="col-lg-6 col-md-12">
                                        <div className="row clearfix">
                                            <div className="col-lg-4 col-md-6">
                                                <div className="card">
                                                    <div className="body">
                                                        <div className="card-value float-right text-muted"><i className="fa fa-building-o"></i></div>
                                                        <h3 className="mb-1">{returnIntData(data?.regionalDataSummaries?.branchesCount)}</h3>
                                                        <div>Branches</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="card">
                                                    <div className="body">
                                                        <div className="card-value float-right text-muted"><i className="fa fa-ticket"></i></div>
                                                        <h3 className="mb-1">{returnIntData(data?.regionalDataSummaries?.tokenIssued)}</h3>
                                                        <div>Issued Token</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="card">
                                                    <div className="body">
                                                        <div className="card-value float-right text-danger"><i className="fa fa-stop"></i></div>
                                                        <h3 className={`mb-1 ${returnIntData(data?.regionalDataSummaries?.waitingCount) !== 0 ? 'blink text-danger' : ''}`}>
                                                            {returnIntData(data?.regionalDataSummaries?.waitingCount)}</h3>
                                                        <div>Total Waitings</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row clearfix">
                                            <div className="col-lg-3 col-md-12 col-sm-12 p-l-5 p-r-5 m-0">
                                                <div className="card card-with-background-progress" style={{ marginTop: '0px', borderRadius: '15px' }}>
                                                    <div
                                                        className="background-progress"
                                                        style={{
                                                            width: `${returnPercentage(data?.regionalDataSummaries?.serviceLevel)}%`,
                                                            backgroundColor: `${returnColor(data?.regionalDataSummaries?.serviceLevel)}`,
                                                        }}
                                                    ></div>
                                                    <div className="body body-visible" style={{ borderRadius: '15px' }}>
                                                        <div>Service Level</div>
                                                        <div className={`py-4 m-0 text-center h3 ${returnTextColor(data?.regionalDataSummaries?.serviceLevel)}`}>
                                                            {returnPercentage(data?.regionalDataSummaries?.serviceLevel)} %
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-12 col-sm-12 p-l-5 p-r-5 m-0">
                                                <div className="card" style={{ marginTop: '0px', borderRadius: '20px' }}
                                                    onClick={() => {

                                                    }}
                                                >
                                                    <div className="body" style={{ borderRadius: '15px' }}>
                                                        <div>Abandonment</div>
                                                        <div className="py-4 m-0 text-center h3 text-light-green">
                                                            {returnIntData(data?.regionalDataSummaries?.noShowCount)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-12 col-sm-12 p-l-5 p-r-5 m-0">
                                                <div className="card card-with-background-progress" style={{ marginTop: '0px', borderRadius: '20px' }}
                                                    onClick={() => {

                                                    }}
                                                >
                                                    <div
                                                        className="background-progress"
                                                        style={{
                                                            width: `${returnPercentage(data?.staffOccupancy)}%`,
                                                            backgroundColor: `${returnColor(data?.regionalDataSummaries?.staffOccupancy)}`,
                                                        }}
                                                    ></div>
                                                    <div className="body" style={{ borderRadius: '15px' }}>
                                                        <div>Staff Occupancy</div>
                                                        <div className={`py-4 m-0 text-center h3 ${returnTextColor(data?.staffOccupancy)}`}>
                                                            {returnPercentage(data?.staffOccupancy)} %
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-12 col-sm-12 p-l-5 p-r-5 m-0">
                                                <div className="card" style={{ marginTop: '0px', borderRadius: '20px' }}
                                                    onClick={() => {

                                                    }}
                                                >
                                                    <div className="body" style={{ borderRadius: '15px' }}>
                                                        <div>Avg. Service Time</div>
                                                        <div className="py-4 m-0 text-center h3 text-light-green">
                                                            {returnIntData(data?.regionalDataSummaries?.avgServedTime)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row clearfix">
                                            <div className="col-lg-6 col-md-12">
                                                <div className="card" style={{ marginTop: '0px', borderRadius: '20px' }}
                                                    onClick={() => {

                                                    }}
                                                >
                                                    <div className="body" style={{ borderRadius: '15px' }}>
                                                        <h6>Hourly Tokens</h6>
                                                        <RDSBarChart
                                                            hours={data?.arrivalPatterns?.hours}
                                                            counts={data?.arrivalPatterns?.counts}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <div className="card" style={{ marginTop: '0px', borderRadius: '20px' }}
                                                    onClick={() => {

                                                    }}
                                                >
                                                    <div className="body" style={{ borderRadius: '15px' }}>
                                                        <h6>Last 7 days Tokens</h6>
                                                        <RDSWeeklyChart
                                                            days={data?.last7daysData?.days}
                                                            counts={data?.last7daysData?.counts}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-12">
                                        <div className="table-responsive">
                                            <table className="table table-custom spacing5">
                                                <thead>
                                                    <tr>
                                                        <th>Branch</th>
                                                        <th>Couneters</th>
                                                        <th>Waiting Tokens</th>
                                                        <th>Max Waitings</th>
                                                        <th>Avg. Wait time</th>
                                                        <th>Issued Tokens</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Array.isArray(data?.regionalDataTables) &&
                                                        data.regionalDataTables.map((b, i) => (
                                                            <tr key={i}>
                                                                <td>{b.name}</td>
                                                                <td><span
                                                                    className={`${b.tellers > 0 ? 'text-info' : ''}`}>{b.tellers}</span> / {b.counters}
                                                                </td>
                                                                <td className={`${b.waiting > 0 ? 'text-danger' : ''}`}>{b.waiting}</td>
                                                                <td>{b.maxWaitingTime}</td>
                                                                <td>{b.avgWaiting}</td>
                                                                <td>{b.total}</td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="row clearfix">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="card body-visible">
                                            <InfiniteScrollRow branchWiseServiceLevels={data?.branchWiseServiceLevels} />
                                        </div>
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    )
}

export default DashboardContentModal